<script>
  import ColorBar from "./ColorBar.svelte";
  import Icon from "../ui/Icon.svelte";
  import LangSpan from "../ui/LangSpan.svelte";

  export let legendLink;
</script>

<div class="cna-legend">
  <h1><LangSpan key="legend-title" /></h1>
  <ColorBar />
  <a class="cna-legend__row" href={legendLink} target="_blank">
    <Icon name="play" />
    <LangSpan key="legend-description" />
  </a>
</div>

<style>
  .cna-legend {
    position: fixed;
    bottom: 10px;
    left: 10px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 3px 0 rgba(0, 0, 0, 0.06);
    background: white;
    border-radius: 5px;
    padding: 0.8rem 1.25rem;
  }

  .cna-legend__row {
    display: none;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: black;
  }

  .cna-legend h1 {
    font: 0.9rem sans-serif;
    margin: 0;
    color: #222;
  }

  @media (min-width: 768px) {
    .cna-legend__row {
      display: flex;
    }
  }
</style>
